/*
  PEFSA — mobile menu accessibility. The official menu button has no accessible name,
  Escape does not close the drawer, and Tab walks out to the page hidden behind it.
  This keeps official header-drawer.liquid untouched.
*/
(function () {
  var summary = document.querySelector('summary[aria-controls="Menu-Drawer"]');
  if (!summary) return;
  var details = summary.parentElement;
  var focusable = 'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function syncLabel() {
    summary.setAttribute('aria-label', details.open ? 'Cerrar menú' : 'Abrir menú');
  }
  syncLabel();
  details.addEventListener('toggle', syncLabel);

  // Items inside a closed <details> have no client rects, so they are skipped.
  function visibleStops() {
    return Array.prototype.filter.call(details.querySelectorAll(focusable), function (el) {
      return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!details.open) return;
    if (event.key === 'Escape') {
      summary.click();
      summary.focus();
      return;
    }
    if (event.key !== 'Tab') return;

    // Keep focus inside the open drawer: the page behind it is covered and cannot scroll.
    var stops = visibleStops();
    if (!stops.length) return;
    var first = stops[0];
    var last = stops[stops.length - 1];
    var active = document.activeElement;
    if (!details.contains(active)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
